export const ImageList = [
    { key: '1', isPrimary: true, mediaStoreId: '' },
    { key: '2', isPrimary: false, mediaStoreId: '' },
    { key: '3', isPrimary: false, mediaStoreId: '' },
    { key: '4', isPrimary: false, mediaStoreId: '' },
    { key: '5', isPrimary: false, mediaStoreId: '' },
    { key: '6', isPrimary: false, mediaStoreId: '' }
]


export const SizeMap = [
    { key: 'XXXXX-Small', value: '5XS' },
    { key: 'XXXX-Small', value: '4XS' },
    { key: 'XXX-Small', value: '3XS' },
    { key: 'XX-Small', value: '2XS' },
    { key: 'X-Small', value: 'XS' },
    { key: 'Small', value: 'S' },
    { key: 'Medium', value: 'M' },
    { key: 'Large', value: 'L' },
    { key: 'XXXXX-Large', value: '5XL' },
    { key: 'XXXX-Large', value: '4XL' },
    { key: 'XXX-Large', value: '3XL' },
    { key: 'XX-Large', value: '2XL' },
    { key: 'X-Large', value: 'XL' },
];

export const SizeToValueMapper = {
    "XXXXX-Small": '5XS',
    "XXXX-Small": '4XS',
    "XXX-Small": '3XS',
    "XX-Small": '2XS',
    "X-Small": 'XS',
    "Small": 'S',
    "Medium": 'M',
    "Large": 'L',
    "XXXXX-Large": '5XL',
    "XXXX-Large": '4XL',
    "XXX-Large": '3XL',
    "XX-Large": '2XL',
    "X-Large": 'XL',
}

export const FOOTWEAR_CATEGORY_ID = "af07e2a8-f218-4697-bb0c-9f240c5bc1d3";